import PropTypes from "prop-types";
import Spinner from "vino/core/Spinner";
import Message from "vino/core/Message";

const Layout = ({ children }) => {
	return (
		<div id="vino-layout" className="w-full flex h-full">
			<div className="flex flex-col flex-auto">{children}</div>
			<Message />
			<Spinner />
		</div>
	);
};

Layout.propTypes = {
	children: PropTypes.node,
};

export default Layout;
